export const SEARCH_FORM_MAIN_INPUT_SEARCH_FIELD_TEST_ID = {'data-testid': 'main-input-field'};

export const SEARCH_FORM_ORGANIZATION_SEARCH_PARAMETER_SEARCH_FIELD_TEST_ID = {
  'data-testid': 'organization-search-parameter-input-field'
};

export const SEARCH_FORM_SHOW_MORE_BUTTON_TEST_ID = 'button-show-more';

export const SEARCH_FORM_ORGANIZATION_SEARCH_PARAMETER_ADD_BUTTON_TEST_ID = 'add-organization-search-parameter-button';

export const DISCLOSURE_COMPONENT_TEST_ID = 'disclosure-component';

export const DISCLOSURE_RESTRICTED_ICON_TEST_ID = 'restricted-icon';

export const DISCLOSURE_NOT_RESTRICTED_ICON_TEST_ID = 'not-restricted-icon';

export const ACCORDION_TABLE_COMPONENT_TEST_ID = 'accordion-table-component';

export const PROFILE_INFO_WHITE_BUTTON_TEST_ID = 'profile-info-white-button';

export const PROFILE_INFO_POPOVER_TEST_ID = 'profile-popover';

export const FILTERED_RESTRICTIONS_FILTERED_RESTRICTION_TEST_ID = 'filtered-restriction';

export const SEARCH_RESULTS_COMPONENT_TEST_ID = 'search-results-component';

export const SEARCH_RESULTS_PATIENT_ICON_TEST_ID = 'patient-icon';

export const SEARCH_RESULTS_ORGANIZATION_ICON_TEST_ID = 'organization-icon';

export const SEARCH_RESULTS_RESOURCE_TEST_ID = 'result-resource-id';

export const SEARCH_FORM_COMPONENT_TEST_ID = 'search-form-component';

export const APP_HEADER_COMPONENT_TEST_ID = 'app-header-component';

export const PROFILE_INFO_COMPONENT_TEST_ID = 'profile-info-component';

export const SEARCH_RESULTS_ORGANIZATION_LAST_FULL_UPLOAD_DATE_TEXT_TEST_ID = 'organization-last-full-upload-text';

export const SIDE_BAR_COMPONENT_TEST_ID = 'side-bar-component';

export const REPORTS_COMPONENT_TEST_ID = 'reports-component';
